// extracted by mini-css-extract-plugin
export default {"notiCount":"HeaderNotification_notiCount__aOmDW","header__notificationLabel":"HeaderNotification_header__notificationLabel__+bBtO"};